var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row pt-3 pb-4" }, [
    _c("div", { staticClass: "col-6 text-left" }, [
      _c("div", { staticClass: "right-inner-addon" }, [
        _c("i", {
          staticClass: "fa fa-search",
          attrs: { "aria-hidden": "true" },
        }),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.searchClient,
              expression: "searchClient",
            },
          ],
          staticClass: "form-control search-inactive-clients",
          attrs: {
            id: "inactive-actions-input",
            type: "search",
            placeholder: _vm.$t("inactive-clients.searchFor"),
            autocomplete: "off",
          },
          domProps: { value: _vm.searchClient },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.searchClient = $event.target.value
            },
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          { staticClass: "d-none", attrs: { for: "inactive-actions-input" } },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("inactive-clients.searchFor")) +
                "\n      "
            ),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-6 text-right" }, [
      _c(
        "a",
        {
          staticClass: "btn btn-primary float-right btn-sm mr-2",
          attrs: { href: "#/clients/board" },
        },
        [_vm._v(_vm._s(_vm.$t("inactive-clients.viewActiveClients")))]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }